import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body p-xl-40" }
const _hoisted_2 = { class: "chart-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h6", { class: "card-title fw-semiBold fs-18 mb-30" }, " Top 05 Customer (January) ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_apexchart, {
        type: "donut",
        width: "90%",
        options: _ctx.topCustomerChart,
        series: _ctx.customer
      }, null, 8, ["options", "series"])
    ])
  ]))
}